import { DataStatus } from '@/shared/lib';
import type { ProductDTO } from '../api/types';
import type { Product } from '../model/types';
import { mapProductApplication } from './mapProductApplication';

export const mapProduct = (dto: ProductDTO): Product => {
  return {
    id: dto.id,
    name: dto.name,
    applications: dto.applications.map(mapProductApplication),
    webfunnelLinks: [],
    webfunnelLinksDataStatus: DataStatus.idle,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
